import { Component, OnInit, Input } from '@angular/core';

import { InvestOutput } from '@classes/invest/invest-bbc/invest-output';

@Component({
    selector: 'app-compare',
    templateUrl: './compare.component.html',
    styleUrls: ['./compare.component.scss']
})
export class CompareComponent implements OnInit {
    @Input() dataBlocks: InvestOutput[];

    constructor( ) { }

    ngOnInit() {
    }

}
